import styled from 'styled-components';
import { breakpoints } from '../../../../styles/theme';
import { StockModelPageStyled } from '../StockModelPageStyled';
import { rem } from 'polished';

export const StockModelPageStyledAP = styled(StockModelPageStyled)`
    .filter-container {
        margin-top: ${rem('20px')};
        @media (max-width: ${breakpoints.md}px) {
            padding: unset;
        }
        .filters-opened {
            @media (max-width: ${breakpoints.md}px) {
                background: ${({ theme }) => theme.colors.white};
            }
        }
    }
    .showMore {
        &--btn {
            border: 1px solid ${({ theme }) => theme.colors.primary};
            background-color: ${({ theme }) => theme.colors.white};
            color: ${({ theme }) => theme.colors.black};
        }

        &--pagination > .pagination > li > a {
            background: unset;
            border: unset;
            font-family: 'Peugeot', sans-serif;
            font-size: ${rem('16px')};
            color: ${({ theme }) => theme.colors.blue7};
        }

        &--pagination > .pagination > .active > a {
            background: unset;
            border: unset;
            color: ${({ theme }) => theme.colors.primary};
        }
    }
`;
